import React, { useState } from 'react';
import { Logo } from './Logo';
import { MenuIcon, XIcon } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  return <header className="w-full py-4 px-4 sm:px-6 lg:px-8 bg-white shadow-sm" data-id="element-163">
      <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-164">
        <Link to="/" data-id="element-165">
          <Logo data-id="element-166" />
        </Link>
        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-8" data-id="element-167">
          {isHomePage ? <>
              <a href="#verticals" className="text-gray-600 hover:text-indigo-600 transition-colors" data-id="element-168">
                Solutions
              </a>
              <a href="#features" className="text-gray-600 hover:text-indigo-600 transition-colors" data-id="element-169">
                Features
              </a>
            </> : <>
              <Link to="/" className="text-gray-600 hover:text-indigo-600 transition-colors" data-id="element-170">
                Home
              </Link>
            </>}
          <Link to="/about" className="text-gray-600 hover:text-indigo-600 transition-colors" data-id="element-171">
            About
          </Link>
          <a href={isHomePage ? '#cta' : '/#cta'} className="text-gray-600 hover:text-indigo-600 transition-colors" data-id="element-172">
            Contact
          </a>
          <a href={isHomePage ? '#cta' : '/#cta'} className="bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700 transition-colors" data-id="element-173">
            Get Started
          </a>
        </nav>
        {/* Mobile menu button */}
        <button className="md:hidden text-gray-600" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-174">
          {isMenuOpen ? <XIcon size={24} data-id="element-175" /> : <MenuIcon size={24} data-id="element-176" />}
        </button>
      </div>
      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden mt-4 px-4" data-id="element-177">
          <nav className="flex flex-col space-y-4" data-id="element-178">
            {isHomePage ? <>
                <a href="#verticals" className="text-gray-600 hover:text-indigo-600 transition-colors py-2" onClick={() => setIsMenuOpen(false)} data-id="element-179">
                  Solutions
                </a>
                <a href="#features" className="text-gray-600 hover:text-indigo-600 transition-colors py-2" onClick={() => setIsMenuOpen(false)} data-id="element-180">
                  Features
                </a>
              </> : <Link to="/" className="text-gray-600 hover:text-indigo-600 transition-colors py-2" onClick={() => setIsMenuOpen(false)} data-id="element-181">
                Home
              </Link>}
            <Link to="/about" className="text-gray-600 hover:text-indigo-600 transition-colors py-2" onClick={() => setIsMenuOpen(false)} data-id="element-182">
              About
            </Link>
            <a href={isHomePage ? '#cta' : '/#cta'} className="text-gray-600 hover:text-indigo-600 transition-colors py-2" onClick={() => setIsMenuOpen(false)} data-id="element-183">
              Contact
            </a>
            <a href={isHomePage ? '#cta' : '/#cta'} className="bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700 transition-colors w-full text-center" onClick={() => setIsMenuOpen(false)} data-id="element-184">
              Get Started
            </a>
          </nav>
        </div>}
    </header>;
};